import React, { useEffect } from 'react';
import { StatusBar } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { AuthProvider } from './src/context/AuthContext';
import { AppNavigator } from './src/navigation/AppNavigator';
import { NotificationProvider } from './src/context/NotificationContext';
import { ErrorBoundary } from './src/utils/ErrorBoundary';
import { Logger } from './src/utils/logger';
import { Colors } from './src/theme/colors';
import { ThemeProvider } from './src/context/ThemeContext';
import { MotionProvider } from './src/components/motion/Motion';

if (__DEV__) {
  Logger.info('App', 'DigitalCampus Parent — WEB build starting');
}

function AppContent() {
  useEffect(() => {
    Logger.info('App', 'Web app initialized');
  }, []);

  return (
    <ErrorBoundary>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <SafeAreaProvider>
          <StatusBar
            barStyle="light-content"
            backgroundColor={Colors.primary}
            translucent={false}
          />
          <ThemeProvider>
            {/* Press, hover and popup animation for every screen (components/motion). */}
            <MotionProvider>
              <AuthProvider>
                <NotificationProvider>
                  <AppNavigator />
                </NotificationProvider>
              </AuthProvider>
            </MotionProvider>
          </ThemeProvider>
        </SafeAreaProvider>
      </GestureHandlerRootView>
    </ErrorBoundary>
  );
}

export default AppContent;
